<template>
    <div>
        <input-group icon="fa fa-calendar">
            <v-select class='form-control'
                      v-model="selectedOption"

                      :options="options"
                      :clearable="false"
                      
                      label='label'

                      close-on-select
            />
        </input-group>
    </div>
</template>

<script>
import api from "@modules/JourneyBuilder/api";
import {bootstrapDangerGrowl} from "@core/Util/growler";

import VSelect from 'vue-select';
import InputGroup from "@core/Components/Inputs/InputGroup";

export default {
    name: "PeriodIdPicker",
    components: {
        VSelect,
        InputGroup
    },
    async created() {
        try {
            this.options = await api.getStatisticsPeriods();
            this.selectedOption = this.options[0];
        } catch (e) {
            bootstrapDangerGrowl(e);
        }
    },
    computed: {
        selectedOption: {
            get(){
                //Default to first option
                return this.options.find(o => o.id === this.value);
            },
            set(value){
                this.$emit('input', value && value.id);
            }
        }
    },
    data() {
        return {
            options: []
        }
    },
    props: {
        value: {
            type: Number,
            required: false
        }
    }
}
</script>
